import React, { useEffect } from 'react';

export default function QdemWebsiteWorkspace({ onBackToHub }) {
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === 'qdem-admin-back') onBackToHub?.();
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onBackToHub]);

  return (
    <div className="min-h-screen bg-[#f6f7f5]">
      <iframe
        title="Q-Dem Website Admin"
        src="/qdem-admin/index.html"
        className="block w-full min-h-screen border-0"
      />
    </div>
  );
}
